import onReady from '../utils/onReady';
import * as Events from '../utils/events';
import Fileupload from './fileupload';
import * as ClassList from '../utils/classList';


/**
 * Implementation of the fileupload box and file list.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class FileuploadDialog {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        // Constants
        this.MODAL = 1;

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container"
            description: container.querySelector(".uploaddlg__description"),
            selectfilebtn: container.querySelector(".uploaddlg__selectfilebtn"),
            uploadbtn: container.querySelector(".uploaddlg__uploadbtn"),
            status: container.querySelector(".uploaddlg__status"),
            filelist: container.querySelector(".uploaddlg__filelist"),

            editbtnSelector: ".uploaddlg__editbtn",
            savebtnSelector: ".uploaddlg__savebtn",
            deletebtnSelector: ".uploaddlg__deletebtn",
            sortableSelector: ".uploaddlg__filelist-header > .sortable > button",
            contenteditable: "[contenteditable]",
            descriptionSelector: ".uploaddlg__filelist-file-description",
            dateSelector: ".uploaddlg__filelist-file-date",
            timeSelector: ".uploaddlg__filelist-file-time"
        };

        /*
         * Inject a input-file html element in the body section of the dom.
         * This has to be done avoid Sitecores Experience Editor scripts to hijack the click events and prevent the file dialog from opening.
        */
        let count = document.querySelectorAll("input[type=file]").length;
        const identifier = "fileuploaddlg_" + count;
        let el = document.createElement("input");
        el.setAttribute("type", "file");
        el.setAttribute("name", identifier);
        el.setAttribute("id", identifier);
        el.style.display = "none";
        document.body.appendChild(el);
        this.dom.filedlg = el;

        // The destination of the post request. This resembles the "action" attribute of a standard html form-tag.
        this.destination = container.getAttribute("data-destination");
        // Rootid is an id used in sitecore to identify what library to store the file in
        this.rootid = container.getAttribute("data-rootid");

        // The button the opens the "select file dialog" to choose which file to upload
        if (this.dom.selectfilebtn) {
            Events.addEvent(this.dom.selectfilebtn, "click", (ev) => {
                ev.preventDefault();
                this.dom.filedlg.click();
            });
        }
        // When the user has selected a file, in the "select file" dialog
        if (this.dom.filedlg) {
            Events.addEvent(this.dom.filedlg, "change", this.fileIsChosen.bind(this));
        }
        // The button that initiates the upload process
        if (this.dom.uploadbtn) {
            Events.addEvent(this.dom.uploadbtn, "click", this.uploadbtnClick.bind(this));
        }

        // Eventlistener for  row (file) buttons
        Events.delegateEvent(this.dom.deletebtnSelector, "click", this.deletebtnClick.bind(this), this.dom.container);

        // Eventlistener for edit row (file description) buttons
        Events.delegateEvent(this.dom.editbtnSelector, "click", this.editbtnClick.bind(this), this.dom.container);

        // Eventlistener for save row (file description) buttons
        Events.delegateEvent(this.dom.savebtnSelector, "click", this.updateClick.bind(this), this.dom.container);

        // Eventlisteners for clicking on headers => makes the table sort on that property
        Events.delegateEvent(this.dom.sortableSelector, "click", this.columnHeaderClick.bind(this), this.dom.container);

        // Eventlistener when editing
        Events.delegateEvent(this.dom.contenteditable, "keydown", this.contenteditableKeydown.bind(this), this.dom.container);


    }

    /**
     * When the user clicks a column header.
     * This triggers sorting on the table sorted by that particular property.
     * The property is defiend in the attribute "data-sortby" and the direction of the sorting is defined in "data-sortdir"
     *
     * @param {Event} ev
     */
    columnHeaderClick(ev) {
        let sortdir = (ev.target.getAttribute("data-sortdir") === "asc") ? "desc" : "asc";
        ev.target.setAttribute("data-sortdir",sortdir);
        let sortby = ev.target.getAttribute("data-sortby");
        this.sort(sortby, sortdir);
    }

    /**
     * When the user has clicked on the  button for a particular file
     *
     * @param {Event} ev
     */
    deletebtnClick(ev) {
        if (!confirm("Er du sikker på, at du vil slette filen?")) {
            return false;
        }

        // Get fileid whis is used by Sitecore to identify the file
        let fileid = ev.target.closest(".uploaddlg__filelist-file").getAttribute("data-fileid");

        if (!fileid) {
            //console.log("Fileid missing. Can't file");
            this.updateStatus("Kan ikke slette filen. Fil-id mangler.");
            return;
        }

        //  file
        let req = new XMLHttpRequest();
        let url = `/api/file/delete?itemId=${fileid}`;
        //console.log(url);
        req.open('GET', url, true);

        req.onload = () => {
            if (req.status >= 200 && req.status < 400) {
                // Success!
                let data = JSON.parse(req.responseText);
                //console.log("Delete returned ok", data);
                if (data) {
                    let f = ev.target.closest(".uploaddlg__filelist-file");
                    f.parentElement.removeChild(f);
                }
            } else {
                // We reached our target server, but it returned an error
                //console.log("Delete did NOT return ok", req);
                this.updateStatus("Kan ikke slette filen. Serveren melder fejl.");
            }
        };
        req.onerror = (a,b,c) => {
            window.console.log("Unexpeted error when trying to  file",a,b,c);
            this.updateStatus("Ukendt fejl. Prøv igen");
        };
        req.send();
    }

    /**
     * When the user has clicked on the edit button for a particular file.
     * This makes the description editable for that particular file.
     *
     * @param {Event} ev
     */
    editbtnClick(ev) {
        let f = ev.target.closest(".uploaddlg__filelist-file");
        this.enableEditmode(f);

        // f.querySelector(".uploaddlg__filelist-file-description > div").setAttribute("contenteditable","true");
        // f.querySelector(".uploaddlg__filelist-file-datetime .datepart").setAttribute("contenteditable","true");
        // f.querySelector(".uploaddlg__filelist-file-datetime .timepart").setAttribute("contenteditable","true");

    }

    enableEditmode(el) {
        let editableFields = el.querySelectorAll("[contenteditable]");
        [].forEach.call(editableFields, (field) => {
            field.setAttribute("contenteditable","true");
        });
        ClassList.add(el,"editmode");


        // Events.addEvent(el.querySelector(a), "click", (ev) => {
        //     ev.preventDefault();
        // });

    }

    disableEditmode(el) {
        let editableFields = el.querySelectorAll("[contenteditable]");
        [].forEach.call(editableFields, (field) => {
            field.setAttribute("contenteditable","false");
        });
        ClassList.remove(el,"editmode");
        //Events.removeEvent(el.querySelector(a), "click");
    }

    /**
     * When the user has clicked on the save button for a particular file.
     * This saves the description for this file by initiation a call to the server.
     *
     * @param {Event} ev
     */
    updateClick(ev) {
        //ev.target.preventDefault();

        let f = ev.target.closest(".uploaddlg__filelist-file");

        let fileid = f.getAttribute("data-fileid");
        let descriptionEdit = f.querySelector(this.dom.descriptionSelector + " > [contenteditable]");
        let descriptionDisp = f.querySelector(this.dom.descriptionSelector + " > a > div");
        let date = f.querySelector(this.dom.dateSelector).innerText;
        let time = f.querySelector(this.dom.timeSelector).innerText;

        // let dateRegEx = new RegExp("(\d{2})\.(\d{2})\.(\d{4})", "g");
        // let timeRegEx = new RegExp("(\d{2}):(\d{2})", "g");

        let dateparts = /(\d{2})\.(\d{2})\.(\d{4})/g.exec(date);
        let timeparts = /(\d{2}):(\d{2}):(\d{2})/g.exec(time);

        if (dateparts === null || dateparts.length !== 4 || timeparts === null || timeparts.length !== 4) {
            // Error - invalid date/time format
            this.updateStatus("Ugyldigt dato/tidsformat. Det skal være på formen: dd.mm.yyyy hh:mm:ss. F.eks. 31.10.2017 23:59:42", this.MODAL);
            return;
        }

        let dd = dateparts[1];
        let MM = dateparts[2];
        let yyyy = dateparts[3];

        let HH = timeparts[1];
        let mm = timeparts[2];
        let ss = timeparts[3];

        let datetime = `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;

        //console.log("Text content, fileid", descriptionEdit.innerText, datetime, fileid, dateparts, timeparts);

        // Update description
        let req = new XMLHttpRequest();
        let url = `/api/file/update?itemId=${fileid}&description=${encodeURI(descriptionEdit.innerText)}&dateTime=${datetime}`;
        // console.log(url);
        req.open('GET', url, true);

        req.onload = () => {
            if (req.status >= 200 && req.status < 400) {
                // Success!
                let data = JSON.parse(req.responseText);
                //console.log("update returned ok", data);
                this.disableEditmode(f);
                descriptionDisp.innerText = descriptionEdit.innerText;
            } else {
                // We reached our target server, but it returned an error
                //console.log("update did NOT return ok", req);
                this.updateStatus("Fejl ved opdatering af række. Tjek om dato/tidsformatet er korrekt. Det skal være på formen: dd.mm.yyyy hh:mm:ss. F.eks. 31.10.2017 23:59:42.", this.MODAL);
            }
        };
        req.onerror = (a,b,c) => {
            window.console.log("Unexpeted error when trying to update file",a,b,c);
        };
        req.send();

    }

    /**
     * When the user has selected a file in the standard file selection box.
     *
     * @param {Event} ev
     */
    fileIsChosen() {
        this.dom.description.value = this.dom.filedlg.files[0].name;
        this.dom.selectfilebtn.querySelector("a").innerText = this.dom.filedlg.files[0].name;
    }

    /**
     * While the user is editing any content editable "field"
     *
     * @param {Event} ev
     */
    contenteditableKeydown(ev) {
        if (ev.event.keyCode === 13) {
            // Enter
            ev.event.preventDefault();
            ev.target.blur();
            this.updateClick(ev.event);
        }
    }

    /**
     * When the user has clicked on the upload button.
     *
     * @param {Event} ev
     */
    uploadbtnClick() {
        // Validation check..

        let extraFields = [];
        extraFields.push({name: 'description', value: this.dom.description.value});
        extraFields.push({name: 'rootId', value: this.rootid});

        this.upload(this.dom.filedlg.files[0], extraFields);
    }

    /**
     * Initiates the upload by the use of the FileUpload class.
     *
     * @param {File} file The file that is to be uploaded.
     * @param {Array} extraFields An array of objects on the form: {name: string, value: string}. Resembles the value of input fields in a standard html-form.
     */
    upload(file, extraFields) {
        if (!this.validate()) {
            return false;
        }

        this.file = file;

        this.uploader = new Fileupload(file, extraFields, this.destination);

        // Overwrite of the "onuploadend" method that is defiend in the Fileupload class. It is called by the Fileupload class when the file has been uploaded.
        this.uploader.onloadend = (status) => {
            let pct = 100;
            let s = `Filen ${this.file.name} er nu uploaded!`;
            let snip = `
                        <div class="uploaddlg__status-text">${s}</div>
                        <div style="width: ${pct}%;" class="uploaddlg__status-bar"></div>
                        `;
            this.dom.status.innerHTML = snip;
            //console.log(snip, status);

            window.location = window.location;
        };

        // Overwrite of the "onuploadprogress" method that is defiend in the Fileupload class. It is called by the Fileupload class while the file is beeing uploaded. It enable us display a progressbar.
        this.uploader.onprogress = (status, loaded, total) => {
            let pct = Math.round(loaded/total * 100);
            let s = `Uploader ${this.file.name} ${pct}%`;
            //console.log(s);
            let snip = `
                        <div class="uploaddlg__status-text">${s}</div>
                        <div style="width: ${pct}%;" class="uploaddlg__status-bar"></div>
                        `;
            this.dom.status.innerHTML = snip;
        };

        // Some error has occured during upload. We tell the user, that an error has occured.
        this.uploader.onerror = (status) => {
            let s = `Fejl: ${status}`;
            window.console.log(s);
            this.dom.status.innerHTML = s;
        };

        // Inititate the upload
        this.uploader.upload();
    }

    /**
     * Sorts
     *
     * @param {String} sortBy   The property that the table should be sorted by
     * @param {String} sortDir  The direction the table should be sorted.
     */
    sort(sortBy, sortdir) {
        let elementsArr = Array.prototype.slice.call(this.dom.filelist.querySelectorAll(".uploaddlg__filelist-file"));
        elementsArr.sort((a,b) => {
            let attr = `data-${sortBy}`;
            a = a.getAttribute(attr).toLowerCase();
            b = b.getAttribute(attr).toLowerCase();

            let val = 0; // The same as the the two are equal
            if (a === b) {
                val = 0;
            }
            else if (sortdir === "asc") {
                // Ascending sorting
                val = (a > b ? 1 : -1);
            }
            else {
                // Descending sorting
                val = (a < b ? 1 : -1);
            }
            return val;
        });

        [].forEach.call(elementsArr, (el) => {
            this.dom.filelist.appendChild(el);
        });

        let sortables = this.dom.filelist.querySelectorAll(".sortable");
        [].forEach.call(sortables, (el) => {
            if (el.getAttribute("data-sortby") === sortBy) {
                el.setAttribute("data-sortedby","true");
            }
            else {
                el.setAttribute("data-sortedby","false");
            }
        });


    }

    updateStatus(s, statustype) {
        switch (statustype) {
            case this.MODAL:
                alert(s);
                break;

            default:
                this.dom.status.innerHTML = s;
        }

    }

    validate() {
        // File
        if (this.dom.filedlg.files.length === 0) {
            this.updateStatus("Du mangler at vælge en fil");
            return false;
        }

        // Description
        if (this.dom.description.value === "") {
            this.updateStatus("Du mangler at angive en beskrivelse");
            return false;
        }

        // Filetype
        let extension = "";
        let i = this.dom.filedlg.files[0].name.lastIndexOf(".");
        if (i > 0) {
            extension = this.dom.filedlg.files[0].name.substr(i+1);
        }
        let allowedFileextensions = this.dom.container.querySelector(".uploaddlg__uploadsection").getAttribute("data-allowedfiletypes").split(",");
        if (!extension || allowedFileextensions.indexOf(extension) < 0) {
            this.updateStatus("Den valgte fil er ikke en tilladt filtype");
            return false;
        }

        // Filesize
        if (this.dom.filedlg.files[0].size > (this.dom.container.getAttribute("data-maxfilesizemb") * 1000000) ) {
            this.updateStatus("Den valgte fil overstiger den tilladte maksimale filstørrelse.");
            return false;
        }
        return true;
    }
}

export default FileuploadDialog;